(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-related"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-related');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          const swiper = new Swiper('.product-related__swiper', {
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
              768: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              991: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            },
            navigation: {
              nextEl: '.product-related__arrows .arrow-filled:last-child',
              prevEl: '.product-related__arrows .arrow-filled:first-child',
            },
            pagination: {
              el: '.pagination',
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-related');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
